module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container noselect",
    attrs: {
      "id": 'note-card-' + _vm.id
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "card",
    class: "left-" + _vm.get_card_class()
  }, [_c('div', {
    staticClass: "main"
  }, [_c('h1', [_vm._v(_vm._s(_vm.note.label))]), _c('i', {
    staticClass: "remove icon",
    class: _vm.expanded ? "shown" : "",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return; }
        _vm.remove($event)
      }
    }
  })]), _c('div', {
    staticClass: "comments",
    class: _vm.expanded ? "shown" : "",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('edit-comment', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.desc),
      expression: "desc"
    }],
    domProps: {
      "value": (_vm.desc)
    },
    on: {
      "input": function($event) {
        _vm.desc = $event
      }
    }
  }), _c('div', {
    staticClass: "sub-comments"
  }, [_vm._l((_vm.comments), function(comment) {
    return _c('edit-comment', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (comment.content),
        expression: "comment.content"
      }],
      attrs: {
        "by": _vm.get_user(comment.by)
      },
      domProps: {
        "value": (comment.content)
      },
      on: {
        "input": function($event) {
          comment.content = $event
        }
      }
    })
  }), _c('div', {
    staticClass: "add-comment",
    on: {
      "click": _vm.add_comment
    }
  }, [_c('i', {
    staticClass: "pencil icon"
  })])], 2)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0985c5a6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoteCard.vue
// module id = 50
// module chunks = 0